import React, { useEffect, useState } from "react";
import moment from 'moment';
import { Row, Col, Modal, Table, Divider, Statistic } from "antd";
import { ExclamationCircleOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";

import { FormatNumber } from "../../../ValueObjects";
import api from "../../../services/api";
import ModalSenhaGerencial from "../senhaGerencial";

export default function ModalParcelasPendentes({ dadosParcelas, exibirModal, fecharModal, fecharModalOk, formulario }) {
    const [abreModalLiberacao, setAbreModalLiberacao] = useState(false);
    const [toleranciaParcelas, setToleranciaParcelas] = useState(null);
    const [acaoParcelaVencida, setAcaoParcelaVencida] = useState(null);

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                formulario.setFieldsValue({ fpg_id: null });
                formulario.setFieldsValue({ cpg_id: null });
                fecharModal();
            }
        });
    };

    const fecharModalVendaBloqueada = () => {
        formulario.setFieldsValue({ fpg_id: null });
        formulario.setFieldsValue({ cpg_id: null });
        fecharModal();
    };

    const fecharModalAviso = () => {
        fecharModalOk();
    };

    const solicitarPermissao = () => {
        debugger
        setAbreModalLiberacao(true);
    };

    const onCloseModalLiberacao = (retorno) => {
        setAbreModalLiberacao(false);
        if (retorno) {
            fecharModalOk(() => {
                console.log("Callback executado após fechar modal de parcelas pendentes");
            });
        }
    };

    useEffect(() => {
        if (exibirModal) {
            carregarDados();
        }
    }, [exibirModal]);

    const carregarDados = async () => {

        const retTolerancia = await api.get(`ParametroEmpresa/BuscarParametrosEmpresa`)

        setToleranciaParcelas(retTolerancia.data.par_diastolparcelavencida ?? 0);
        setAcaoParcelaVencida(retTolerancia.data.par_acaoparcelavencida)
    };

    return (
        <Modal
            centered
            title="Parcelas em Atraso"
            open={exibirModal}
            width={600}
            onCancel={onCloseModal}
            onOk={acaoParcelaVencida === 3 ? fecharModalVendaBloqueada : acaoParcelaVencida === 1 ? fecharModalAviso : solicitarPermissao}
            okText={[1, 3].includes(acaoParcelaVencida) ? 'Ok' : 'Solicitar permissão para venda a prazo'}
            okButtonProps={{
                icon: <CheckOutlined />,
                type: 'primary'
            }}
            cancelText="Cancelar"
            cancelButtonProps={{
                icon: <CloseOutlined />,
                style: { display: [1, 3].includes(acaoParcelaVencida) ? 'none' : 'inline-block' }
            }}
            maskClosable={false}
        >
            <div>
                <Row gutter={16} style={{ marginBottom: 16 }}>

                    {acaoParcelaVencida === 3 && (
                        <Col span={24}>
                            <div style={{ marginBottom: 12, textAlign: 'center' }}>
                                <b>
                                    <ExclamationCircleOutlined style={{ marginRight: 6 }} />
                                    Venda a prazo bloqueada.
                                </b> Cliente possui parcelas em atraso.
                            </div>
                        </Col>
                    )}

                    <Col span={12}>
                        <Statistic
                            title="Tolerância de Parcelas"
                            value={toleranciaParcelas}
                            suffix="Dias"
                        />
                    </Col>

                    <Col span={12}>
                        <Statistic
                            title="Nº Parcelas em Atraso"
                            value={dadosParcelas?.length || 0}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Col>

                </Row>
                <Row>
                    <Col span={24}>
                        <Table
                            size="small"
                            bordered
                            pagination={false}
                            scroll={{ y: 300 }}
                            
                            rowKey={(record, index) => index}
                            dataSource={dadosParcelas}
                            columns={[
                                {
                                    title: 'Nº Documento',
                                    dataIndex: 'cpr_numerodocumento',
                                    align: 'left',
                                    render: (value) => <>{value}</>,
                                },
                                {
                                    title: 'Parcela',
                                    dataIndex: 'prc_numeroparcela',
                                    align: 'center',
                                    render: (value) => <>{value}</>,
                                },
                                {
                                    title: 'Data Vencimento',
                                    dataIndex: 'prc_datavencimento',
                                    align: 'center',
                                    render: (value) => (
                                        <span className="text-danger">
                                            {moment(value).format('DD/MM/YYYY')}
                                        </span>
                                    ),
                                },
                                {
                                    title: 'Valor (R$)',
                                    dataIndex: 'prc_valor',
                                    align: 'right',
                                    render: (value) => (
                                        <b>
                                            {FormatNumber(value, true)}
                                        </b>
                                    ),
                                },
                            ]}
                            summary={(pageData) => {
                                const total = pageData.reduce((sum, row) => sum + row.prc_valor, 0);

                                return (
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0} colSpan={3} align="right">
                                            <b>Total em atraso</b>
                                        </Table.Summary.Cell>

                                        <Table.Summary.Cell index={3} align="right">
                                            <b>{FormatNumber(total, true)}</b>
                                        </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                );
                            }}
                            locale={{
                                emptyText: (
                                    <Divider orientation="center">
                                        <ExclamationCircleOutlined /> Nenhum Registro Encontrado
                                    </Divider>
                                )
                            }}
                        />
                    </Col>
                    <ModalSenhaGerencial exibirModalSenhaGerencial={abreModalLiberacao} fecharModalSenhaGerencial={onCloseModalLiberacao} />
                </Row>
            </div>
        </Modal>
    );
}